import { useState } from "react";
import {useTranslation} from "@i18n";
import { CDN_LINK } from "@globalConfig";
import SharedPopUp from "@componentsShared/BottomSheetPopup__OLD/SharedPopUp";
import stl from "./FuelEco.module.css";

const FuelEco = ({ fuelEco }) => {
  const {t} = useTranslation();
  const [sharePopUp, setSharePopUp] = useState(false);

  const showSharePopUp = () => {
    setSharePopUp(true);
  };

  const hideSharePopUp = () => {
    setSharePopUp(false);
  };

  const listOfLevel = Object.values(fuelEco.list_of_level);


  return (
      <>
        <div className={stl.FuelEcoContainer}>
          <div>
            <img src={CDN_LINK + `/assets/images/fuelEco.svg`} alt="" />
            <strong>
              {t("اقتصاد الوقود", {
                ns: "web_post_view",
              })}
              <span>
              {t("(كم/لتر)", {
                ns: "web_post_view",
              })}
            </span>
            </strong>
          </div>
          <div className={stl.showEcoCard}>
            <div
                className={[
                  stl.singleEcoRow,
                  fuelEco.level_class.replace(" ", ""),
                ].join(" ")}
            >
              <span>{fuelEco.level_name}</span>
              <span>{fuelEco.fuel_economy}</span>
            </div>
            <span onClick={showSharePopUp}>
            {t("اعرض البطاقة", {
              ns: "web_post_view",
            })}
          </span>
          </div>
        </div>

        <SharedPopUp show={sharePopUp} onClose={hideSharePopUp}>
          <div className={stl.EcoPopUpContent}>
            <div className={stl.flexBet}>
              <strong>
                {t("اقتصاد الوقود", {
                  ns: "web_post_view",
                })}
              </strong>
              <strong>
                {fuelEco.fuel_economy}
                <span>
                {t("(كم/لتر)", {
                  ns: "web_post_view",
                })}
              </span>
              </strong>
            </div>
            <div className={stl.flexBet}>
              <strong>
                {t("نوع الوقود", {
                  ns: "web_post_view",
                })}
              </strong>
              <strong>{fuelEco.fuel_type}</strong>
            </div>
            <div
                className={[
                  stl.ecoBoxLines,
                  fuelEco.level_class.replace(" ", ""),
                ].join(" ")}
            >
              {listOfLevel.map((item, i) => (
                  <div className={stl.showEcoCard} key={i}>
                    <div className={stl.singleEcoRow}>
                      <span>{item.ar}</span>
                      <span>{item.en}</span>
                    </div>
                    <div className={stl.singleEcoRow}>
                      {fuelEco.level_id === item.id ? fuelEco.fuel_economy : ""}
                    </div>
                  </div>
              ))}
            </div>
            <div className={stl.flexCent}>
              <img src={CDN_LINK + `/assets/images/rrr.png`} alt="" />
            </div>
          </div>
        </SharedPopUp>
      </>
  );
};

export default FuelEco;
